<template lang="pug">
#analisar-operacao
    div(v-show='mostrarFormulariosOperacao')
        BaseHeader(
            :titulo="$t('mensagens.operacao.analisar')",
            :voltarPara="true"
            :exibeBotao='false'
        )
            template(slot='direita')
                el-dropdown(trigger='click')
                        BaseButton.analisar-operacao__header__acao__botao(
                            type='primary'
                        )
                            i.el-icon-arrow-down
                            span {{ $t('mensagens.operacao.tabela.acoes') }}
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='flow flow-environment',
                                @click.native='realizarAnaliseSocioambiental()'
                            ) {{ $t('mensagens.operacao.acoes.analisarSocio') }}

        .view-container-base-header
            .titulo-card
                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.dadosGerais') }}
            FormularioDadosGeraisOperacao(
                class='mb-4',
                v-if='verificouSeEcadastroOuEdicao',
                ref='refFormularioDadosGerais',
                @dadosGerais='atualizarDadosGerais',
                :operacaoEditarOuClonar='operacaoEditar'
            )

            .titulo-card
                span {{ $t('mensagens.operacao.atividades') }}
            FormularioAtividadeOperacao(
                class='mb-4',
                v-if='verificouSeEcadastroOuEdicao',
                @dadosAtividades='atualizarAtividades',
                :operacaoEditarOuClonar='operacaoEditar',
                :atividadeObrigatoria='atividadeObrigatoria'
            )

            .titulo-card
                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.pessoaGrupoEconomico') }}
            FormularioPessoaOperacao(
                class='mb-4',
                v-if='verificouSeEcadastroOuEdicao',
                @dadosPessoa='atualizarPessoa',
                :operacaoEditarOuClonar='operacaoEditar',
            )

            .titulo-card
                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.territorioGleba') }}
            FormularioTerritorioGlebaOperacao(
                class='mb-4',
                v-if='verificouSeEcadastroOuEdicao',
                @dadosTerritorioGleba='atualizarTerritorioGleba',
                :dadosEditarOuClonar='operacaoEditar',
                :dadosValidarSobreposicao='validarSobreposicao'
            )

            section.analisar-operacao__acao.mt-3
                BaseButton.mr-2(size='small', @click='$router.go(-1)')
                    | {{ $t('mensagens.comuns.voltar') }}

                BaseButton(
                    @click='realizarAnaliseSocioambiental()',
                    type='primary',
                    size='small'
                )
                    | {{ $t('mensagens.operacao.acoes.analisarSocio') }}

    CardAnaliseSocioambientalOperacao(
        v-if='mostrarCardAnaliseSocioambiental',
        habilitar-analise,
        :habilitar-botao-cadastrar='false',
        :dadosDiagnostico='dadosAnaliseSocioambientalProtocolo',
        @aprovarOperacao='aprovarOperacao',
        @reprovarOperacao='reprovarOperacao',
        @cadastrarOperacao='salvarEdicaoOperacao',
        @fechar='fecharCardAnaliseSocioambientalOperacao'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import OperacaoService from '@/services/OperacaoService';
import FormularioTerritorioGlebaOperacao from '@/components/operacao/gestao/FormularioTerritorioGlebaOperacao.vue';
import CardAnaliseSocioambientalOperacao from '@/components/operacao/gestao/CardAnaliseSocioambientalOperacao.vue';
import FormularioDadosGeraisOperacao from '@/components/operacao/gestao/FormularioDadosGeraisOperacao.vue';
import FormularioAtividadeOperacao from '@/components/operacao/gestao/FormularioAtividadeOperacao.vue';
import FormularioPessoaOperacao from '@/components/operacao/gestao/FormularioPessoaOperacao.vue';
import ExceptionMapper from '@/utils/exceptionMapper';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'AnalisarOperacao',

    components: {
        BaseHeader,
        CardAnaliseSocioambientalOperacao,
        FormularioDadosGeraisOperacao,
        FormularioAtividadeOperacao,
        FormularioPessoaOperacao,
        FormularioTerritorioGlebaOperacao,
        BaseButton
    },

    data() {
        return {
            operacaoEditar: null,
            validarSobreposicao: {
                idOperacao: null,
                idCategoria: null,
                datasPlantio: []
            },
            atividadeObrigatoria: true,
            dadosAnaliseSocioambientalProtocolo: {
                pessoas: [],
                territorios: [],
                glebas: [],
                idOperacao: null
            },
            operacao: {
                dadosGerais: null,
                atividades: [],
                pessoasGrupoEconomico: [],
                territoriosGlebas: []
            },
            verificouSeEcadastroOuEdicao: false,
            mostrarFormulariosOperacao: true,
            mostrarCardAnaliseSocioambiental: false
        };
    },

    async mounted() {
        await OperacaoService.buscarPorId(this.$route.params.id)
            .then(({ data }) => {
                this.operacaoEditar = data;
                this.validarStatusOperacao(data);
                this.verificouSeEcadastroOuEdicao = true;
            })
            .catch(error => {
                this.$notify.error({
                    message: error.message
                });
                this.$router.push({ name: 'operacao' });
            });

        this.validarSobreposicao.idOperacao = this.$route.params.id
            ? this.$route.params.id
            : null;
    },

    methods: {
        validarStatusOperacao(data) {
            if (
                data.analise.codigo !== 'AGUARDANDO_APROVACAO' &&
                data.analise.codigo !== 'EM_ANALISE'
            ) {
                throw new Error(
                    this.$t('mensagens.operacao.notificacao.operacaoNaoPodeSerAnalisada')
                );
            }
        },

        atualizarDadosGerais(dadosGerais) {
            this.operacao.dadosGerais = dadosGerais;
            if (this.operacao.dadosGerais.categoria) {
                this.atividadeObrigatoria =
                    this.operacao.dadosGerais.categoria.atividadeObrigatoria;
            }
            this.validarSobreposicao.idCategoria = dadosGerais.categoria.id;
        },

        atualizarPessoa(dadosPessoas) {
            this.operacao.pessoasGrupoEconomico = dadosPessoas;
        },

        atualizarAtividades(dadosAtividades) {
            this.operacao.atividades = dadosAtividades;
            this.validarSobreposicao.datasPlantio = [];
            this.operacao.atividades.forEach(atividade => {
                if (atividade.inicioPlantio) {
                    this.validarSobreposicao.datasPlantio.push(
                        atividade.inicioPlantio
                    );
                }
            });
        },

        atualizarTerritorioGleba(territoriosGlebas) {
            this.operacao.territoriosGlebas = territoriosGlebas;
        },

        async aprovarOperacao(payload) {
            const idOperacaoGerada = await this.salvarEdicaoOperacao();

            if (idOperacaoGerada) {
                await OperacaoService.aprovar(idOperacaoGerada, payload)
                    .then(() => {
                        this.$notify.success({
                            message: this.$t('mensagens.operacao.notificacao.operacaoAprovada')
                        });
                        this.$router.push({ name: 'operacao' });
                        this.mostrarCardAnaliseSocioambiental = false;
                    })
                    .catch((err) => {

                        if (err.response?.data) {
                            
                            const errorMessage = err.response.data === '[ERRO_PDF]' ? this.$t('mensagens.operacao.notificacao.erroPdf') : err.response.data;
                            
                            this.$notify.error({
                                message: errorMessage,
                                duration: 15000
                            });
                            return;
                        }

                        this.$notify.error({
                            message:
                                this.$t('mensagens.operacao.notificacao.verificarDadosAprovacao'),
                            duration: 15000
                        });
                    });
            }
        },

        async reprovarOperacao(payload) {
            const idOperacaoGerada = await this.salvarEdicaoOperacao();

            if (idOperacaoGerada) {
                await OperacaoService.reprovar(idOperacaoGerada, payload)
                    .then(() => {
                        this.$notify.success({
                            message: this.$t('mensagens.operacao.notificacao.operacaoReprovada')
                        });
                        this.$router.push({ name: 'operacao' });
                        this.mostrarCardAnaliseSocioambiental = false;
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t('mensagens.operacao.notificacao.impossivelReprovarOperacao')
                        });
                    });
            }
        },

        async realizarAnaliseSocioambiental() {
            if (!(await this.validarFormularios())) return;

            this.dadosAnaliseSocioambientalProtocolo = {
                pessoas: [],
                territorios: [],
                idOperacao: this.operacao.id
            };

            const setPessoa = new Set();

            const pessoasUnicas = this.operacao.pessoasGrupoEconomico.filter(
                pessoa => {
                    const duplicada = setPessoa.has(pessoa.cpfCnpj);
                    setPessoa.add(pessoa.cpfCnpj);
                    return !duplicada;
                }
            );

            pessoasUnicas
                .map(e => ({
                    cpfCnpj: e.cpfCnpj,
                    nomeRazaoSocial: e.nomeRazaoSocial
                }))
                .forEach(e => {
                    this.dadosAnaliseSocioambientalProtocolo.pessoas.push(e);
                });

            this.operacao.territoriosGlebas.forEach(territorio => {
                const glebas = territorio.glebas.map(gleba => {
                    return {
                        utilizouAreaTotalTerritorio:
                            territorio.utilizouAreaTotalTerritorio,
                        geometria: gleba.geometria,
                        nome: gleba.nome
                    };
                });

                this.dadosAnaliseSocioambientalProtocolo.territorios.push({
                    idTerritorio: territorio.idTerritorio,
                    glebas
                });
            });

            this.dadosAnaliseSocioambientalProtocolo.idOperacao = this.$route.params.id;

            this.mostrarFormulariosOperacao = false;
            this.mostrarCardAnaliseSocioambiental = true;
        },

        fecharCardAnaliseSocioambientalOperacao() {
            this.mostrarFormulariosOperacao = true;
            this.mostrarCardAnaliseSocioambiental = false;
        },

        async salvarEdicaoOperacao() {
            if (!(await this.validarFormularios())) return;

            if (this.operacao.dadosGerais.valorTotalOperacao === 0) {
                this.operacao.dadosGerais.valorTotalOperacao = null;
            }

            return OperacaoService.editar(
                this.operacao,
                this.operacaoEditar.dadosGerais.id
            )
                .then(({ data }) => data.idOperacaoGerada)
                .catch(err => {
                        if (err.response?.status === 409) {
                            this.$notify.error({
                                message: this.$t('mensagens.operacao.notificacao.conflitoEditar')
                            });
                            return;
                        }

                        if (err.response?.data?.message) {
                            
                            const errorMessage = err.response.data.message === '[ERRO_PDF]' ? this.$t('mensagens.operacao.notificacao.erroPdf') : err.response.data.message;
                            
                            this.$notify.error({
                                message: errorMessage,
                                duration: 15000
                            });
                            return;
                        }

                        if (ExceptionMapper(err)) {
                            this.$notify.error({
                                message: err.response.data.message,
                                duration: 15000
                            });
                        }
                    }
                );
        },

        async validarFormularios() {
            if (
                !(await this.$refs.refFormularioDadosGerais.validarFormulario())
            ) {
                this.$notify.warning({
                    message:
                        this.$t('mensagens.operacao.notificacao.campoObrigatorioDadosGerais')
                });
                return false;
            }

            if (
                this.operacao.atividades.length === 0 &&
                this.operacao.dadosGerais.categoria.id < 4
            ) {
                this.$notify.warning({
                    message: this.$t('mensagens.operacao.notificacao.campoObrigatorioAtividades')
                });
                return false;
            }

            if (this.operacao.pessoasGrupoEconomico.length === 0) {
                this.$notify.warning({
                    message:
                        this.$t('mensagens.operacao.notificacao.campoObrigatorioGrupoEconomico')
                });
                return false;
            }

            if (this.operacao.territoriosGlebas.length === 0) {
                this.$notify.warning({
                    message:
                        this.$t('mensagens.operacao.notificacao.campoObrigatorioTerritorio')
                });
                return false;
            }

            return true;
        }
    }
};
</script>

<style lang="scss">
#analisar-operacao {
    height: 100%;
    width: 100%;

    .analisar-operacao__header__acao__botao {
        font-size: 14px;
        color: var(--white);
        background: var(--primary);
        border-color: var(--primary);
        border-radius: $default-border-radius;
        font-weight: map-get($font-weight, normal);
        padding: 12px 20px;
    }

    .analisar-operacao__header {
        margin: 0;
        align-items: center;
        padding: 20px;
        height: 100px;
        width: 100%;
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .analisar-operacao__header__title {
            padding: 0;
            color: var(--primary-font-color);
            font-weight: map_get($font-weight, medium);
            font-size: map-get($font-size, x-large);

            .analisar-operacao__header__title--acao {
                cursor: pointer;
                margin-right: 10px;
                font-size: 22px;
            }
        }
    }

    .analisar-operacao__acao {
        display: flex;
        justify-content: space-between;
    }

    .titulo-card {
        font-size: 16px;
        font-weight: 600;
        padding-bottom: 7px;
    }
}
</style>
